module.exports = __webpack_public_path__ + "img/meter_replace.56c0145d.png";